/**
 * Tatvex Studio - Entry Point
 *
 * React 19 + Vite SPA for configuration management.
 * Deployed to Cloudflare Pages.
 */

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";

/**
 * React Query client configuration.
 *
 * - 1 minute stale time for config data
 * - 5 minute garbage collection time
 * - Single retry for failed queries
 * - No refetch on window focus (manual refresh preferred for config editing)
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found. Check index.html.");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
